// autogenerated by yarn build:dev or yarn build:prod
exports.assetsVersion = () => '415aea8ed';
